import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { message } from "antd";
import { gameApi } from "api/game";
import axios, { CancelTokenSource } from "axios";
import MESSAGE from "contants/message";
import { ResponseCode } from "contants/response";
import { ModalTypeValue } from "enums/modalType";
import { openModal } from "store/master";
import { SubGameType } from "types/game";
let source: CancelTokenSource;

const handleLoginGame = async (
  dataLogin: SubGameType,
  username: string,
  dispatch: Dispatch<AnyAction>,
) => {
  if (!username) {
    message.warning(MESSAGE.loginGame.requiredLoginGame);
    dispatch(openModal(ModalTypeValue.LOGIN));
    return;
  }

  message.loading({
    key: "login-game",
    content: MESSAGE.loginGame.loadingLoginGame,
    duration: 20,
  });

  if (source) {
    source.cancel(MESSAGE.loginGame.cancelRequired);
  }

  const openBlank = window.open("", "LoginGame");

  if (!openBlank) return;
  const loaderElement = openBlank.document.createElement("div");
  const style = openBlank.document.createElement("style");
  loaderElement.className = "loader";
  style.textContent = `
  .loader { height:100%;width:100%;display:flex;justify-content:center;align-items:center;position:fixed;top:0;left:0;background:#333333;} 
  .loader::after{content:"";width:75px;height:75px;border:15px solid #dddddd;border-top-color:#BD161D;border-radius:50%;animation:loading 2s ease infinite} 
  @keyframes loading {
    from { transform: rotate(0turn)}
    to { transform:rotate(1turn)}
  }
  `;
  openBlank.document.body.appendChild(loaderElement);
  openBlank.document.head.appendChild(style);

  source = axios.CancelToken.source();

  try {
    const response = await gameApi.loginGame(username, {
      username,
      game_type: dataLogin.type,
      game_code: dataLogin.game_code,
      provider: dataLogin.provider_code,
      source,
    });

    const dataLoginGame = response.data;

    if (dataLoginGame.status !== ResponseCode.SUCCESS) {
      message.error({
        key: "login-game",
        content: MESSAGE.loginGame.errorLoginGame,
      });
      openBlank.close();
      return;
    }

    message.success({
      key: "login-game",
      content: MESSAGE.loginGame.successLoginGame,
    });

    const openGame = window.open(dataLoginGame.url, "LoginGame");

    if (openGame) {
      window.open(dataLoginGame.url, "LoginGame");
      return;
    }

    alert(MESSAGE.alertPopup);
  } catch (error) {
    if (
      (error as { message: string }).message.includes(
        MESSAGE.loginGame.errorLoginGame,
      )
    ) {
      return;
    }

    message.error({
      key: "login-game",
      content: MESSAGE.loginGame.serverErrorLoginGame,
    });
  }
};
export default handleLoginGame;
